<template>
<div class="home">

  <JumboPanel
    class="acorns-header"
    header="Is your data ready when you need it?">
    <hr class="my-4">
    <p>
      Or is your data scattered in various applications? Collected and stored in multiple formats? Keep data and project management in one application with ACORNS.
    </p>
    <p>
      Read this section to learn more about our ACORNS platform and services
    </p>

    <div>
      <BButton
        variant="success"
        to="/#contact">
        Message us
      </BButton>

      <BButton
        variant="info"
        to="/services">
        Learn more
      </BButton>
    </div>

    <div
      class="jumbo-image"
      slot="image">
      <DataSharing
        height="300"
        width="300"/>
    </div>

  </JumboPanel>

  <CardPanel
    :data="recentProjects">
    <template slot="header">
      <h2>Featured projects</h2>
      <hr/>
    </template>
  </CardPanel>

  <div class="">

  </div>

  <section id="stories">
    <CardPanel
      :data="recentNews">
      <template slot="header">
        <h2>Recent notes</h2>
        <hr/>
      </template>
    </CardPanel>
  </section>


  <section id="services">
    <h2>Our services</h2>
    <CardPanel
      :data="services"/>
  </section>


  <div class="image-panel">
    <div class="content-block"/>
    <div class="image-block"/>
  </div>



  <ContactPanel
    id="contact"
    class="home-contact-panel">
    <h1 class="display-4">Contact Us</h1>
    <hr class="my-3">
    <p class="my-4">
      Don’t see your exact data need described here? Contact us and let’s
      brainstorm together. ACORNS is adaptable. Plus we have years of experience
      solving data management and analysis problems for a variety of environmental fields.
    </p>
  </ContactPanel>


  </div>
</template>

<script>
import InfoPanel from '@/components/sections/InfoPanel';
import LinkPanel from '@/components/sections/LinkPanel';
import CardPanel from '@/components/sections/CardPanel';
import JumboPanel from '@/components/sections/JumboPanel';
import ContactPanel from '@/components/sections/ContactPanel';
import MessageCarouselSection from '@/components/sections/MessageCarouselSection';
import { mapState, mapGetters } from 'vuex'
import ScrollIntoView from '@/mixins/ScrollIntoView';
import DataSharing from '../assets/img/cloud-io.svg'

export default {
  name: 'home',
  mixins: [
    ScrollIntoView,
  ],
  components: {
    CardPanel,
    InfoPanel,
    JumboPanel,
    ContactPanel,
    MessageCarouselSection,
    LinkPanel,
    DataSharing,
  },
  computed:{
    ...mapGetters([
      'activeProjects',
      'activeNews',
    ]),
    ...mapState([
      'services',
      'messages',
      'projects',
      'articles',
      'links',
    ]),
    currentDate(){
      return '2019-08-01';
    },
    recentNews(){
      return this.activeNews
        .slice(0, 8)
    },
    recentProjects(){
      return this.activeProjects
        .slice(0, 4)
    }
  },
  methods:{
    url(file){
      return `url(/img/${file})`;
    },
  }
}
</script>

<style lang="scss">
@import '~@/styles/variables';
.home {

  .acorns-header {
    background-color: $color4 !important;
    .btn {
      margin-right: 0.5rem;
    }
  }

  .jumbo-image {
    height: 100%;
    padding-top: 2rem;
  }

  .home-contact-panel {
    background-color: lighten($color2, 25%);
    padding: 4rem 0;
  }

  .home-link-panel {
    min-height: 20rem;
    background-color: $footer-color;
  }

  .image-panel {
    flex-direction: row;
    height: 35vh;
    border-top:1px solid gray;
    border-bottom:1px solid gray;
    .content-block {
      position: absolute;
      left: 0;
      top: 23%;
      width: 100%;
      text-align: center;
      color: $primary-color;
      z-index: 99;
    }
    .image-block {
      background-image: url(~@/assets/img/acornhand-cut.jpg);
      background-repeat: no-repeat;
      background-size: 120% 110%;
      background-position: bottom center;
      height: 100%;
      width:100%;
      z-index: 8;
    }
  }

  #stories {
    .card {
      text-align: center;
      color: rgba(255,255,255,0.75);
      background-color: $color4;
    //  min-height: 12rem;
    }
  }

  #services {
    max-width: $max-content-width;
    margin: 0 auto;
    .card {
      .card-body {
        padding-top: 0;
        text-align: center;
        .card-title {
          font-size: 200%;
        }
      }
    }
  }

  @media screen and (min-width: $break-sm) {
    .image-panel {
      .image-block {
        background-size: cover;
        background-position: bottom;
      }
    }
  }

  @media screen and (min-width: $break-md) {
    .image-panel {
      .image-block {
        background-size:100% 160%;
      }
    }
  }

  @media screen and (min-width: $break-lg) {
    .image-panel {
      .image-block {
        background-size:100% 200%;
        background-position: bottom -80px center;
      }
    }
  }

  @media screen and (min-width: $break-xl) {
    .acorns-header {
      padding-left: 15rem;
      padding-right: 15rem;
    }

    .image-panel {
      height: 40vh;
      .image-block {
        background-size:100% 240%;
        background-position: bottom -120px center;
      }
    }
  }

  @media screen and (min-width: 1500px) {
    .image-panel {
      height: 45vh;
      .image-block {
        background-size:100% 310%;
        background-position: bottom -210px center;
      }
    }
  }



}
</style>
